<template>
  <el-card v-loading="loading">
    <template slot="header">
      设置参数
    </template>
    <el-form :model="setting"
             :rules="rules"
             ref="ruleForm"
             label-position="right"
             label-width="80px">
      <el-form-item label="配置名" prop="name">
        <el-input v-model="Setting.name"></el-input>
      </el-form-item>
      <el-form-item label="值" prop="value">
        <el-input v-model="Setting.value" v-if="Setting.type == 'text'"></el-input>
        <img-upload v-model="Setting.value" v-if="Setting.type == 'img'" :return-url="true" :default-url="Setting.value" @change="setImg"></img-upload>
        <video-upload v-model="Setting.value" v-if="Setting.type == 'video'" :return-url="true" :default-url="Setting.value" @change="setImg"></video-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="update('ruleForm')">保存</el-button>
        <el-button type="success" @click="back">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  import '@/static/test'
  import ImgUpload from "../img/ImgUpload";
  import VideoUpload from "../video/VideoUpload";

  export default {
    name: "SettingEdit",
    props: {
      id: {
        required: true
      }
    },
    components: {VideoUpload, ImgUpload},
    data() {
      return {
        setting: {}
      }
    },
    computed: {
      ...mapState({
        Setting: state => state.setting.Setting,
        rules: state => state.setting.rules,
        loading: state => state.setting.loading
      })
    },
    methods: {
      setImg(value){

        this.$store.commit('setting/setNewUserDetail', {...this.Setting, value: value});
        console.log(456);
      },
      back() {
        this.$router.back();
      },
      update(form) {
        let vthis = this;

        this.$refs[form].validate((validate) => {
          if (!validate) {
            return;
          }
          this.$store.dispatch('setting/update').then(res => {
            vthis.$confirm('是否关闭页面?')
              .then(_ => {
                vthis.$router.back();
              });
          })
            .catch(res => {
              console.log(res);
            });
        });

      }
    },
    created() {
      this.$store.dispatch('setting/show', {id: this.id});
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/setting/SettingEdit.vue